import {
  faUserTag,
  faSearch,
  faBuilding,
  faExclamationCircle,
  faExclamationTriangle,
  faTimesCircle,
  faUserCheck,
  faUserPlus,
  faSave,
  faSpinner,
  faUser,
  faMobileAlt,
  faEnvelope,
  faMapMarkerAlt,
  faUniversity,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import {
  Modal,
  MixedTabbedDataGroup,
  SearchResultsAdvanced,
  QuantaFormik,
  QuantaForm,
  Text,
  InputGridGroup,
  useResponsiveParams,
  useQuantaFormikContext,
  Button,
  Paper,
  Grid,
  GridItem,
} from 'quanta-ui';
import React, { useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
// import {
//   updateCustomerInformation,
//   updateHealthQuote,
// } from '../_graphql/state';
import { updateCustomerInformation,
  //  updateHealthQuote 
  } from 'quanta-flows/modules/quote/health/state';
import { updateHealthQuote } from '../_graphql/state';
// import {
//   CUSTOMER_DROPDOWN_DETAILS,
//   GET_CUSTOMER_TYPE_DOMAIN,
//   SEARCH_CUSTOMERS,
//   QUERY_STATE,
//   MOBILE_NUMBER_STARTING_WITH,
//   CHARACTER_LIMIT_LIST,
// } from '../queries';
import {
  CUSTOMER_DROPDOWN_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  SEARCH_CUSTOMERS,
  // QUERY_STATE,
  MOBILE_NUMBER_STARTING_WITH,
  CHARACTER_LIMIT_LIST,
} from 'quanta-flows/modules/quote/health';
import { QUERY_STATE } from '../queries';
// import Loading from '../../../../../lib/layout/loading';
import { Loading, Error } from 'quanta-flows/modules/layout';
// import Error from '../../../../../lib/layout/error';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import { useQuery } from '@apollo/client';
// import IconIdle from '../../../../common/icon-search-idle';

const saveQuoteVariables = (
  lobCode,
  productCode,
  custData,
  quotationType,
  members,
  cover,
  healthPlans,
  location,
  existingPolicyNumber,
  isExistingEmployee,
  selectedIntermediary,
  intermediaryDetails,
  deductSumInsured,

) => {
  return {
    input: {
      quotationType: quotationType,
      intermediary: {
        intermediaryCode:
          intermediaryDetails?.code
          || selectedIntermediary.intermediaryCode ,
        intermediaryName:
          intermediaryDetails?.name ||
          selectedIntermediary.intermediaryName ,
        locationCode:
        intermediaryDetails?.location ||
          selectedIntermediary.branchOfficeCode 
          ,
        fieldUserCode:
        intermediaryDetails?.fieldUserCode ||
          selectedIntermediary.fieldUserCode 
          ,
      },
      quoteCreationDate: moment().format('YYYY-MM-DD').toString(),
      customer: custData,
      lob: lobCode,
      product: productCode,
      location: {
        pinCode: location?.pincode,
        state: location?.state,
        district: location?.district,
        city: location?.city,
        zone: location?.zone,
      },
      members: members
        ?.filter((mem) => mem.selected)
        ?.map((member) => {
          return {
            relationship: member?.relationship,
            gender: member?.gender,
            dob: member?.dob,
            age: member?.age?.toString(),
          };
        }),
      cover: {
        type: cover?.type,
        sumInsured: parseInt(cover?.sum_insured),
        tenure: cover?.tenure,
        deductibleSumInsured: parseInt( deductSumInsured),
        // parseInt(cover?.deductibleSumInsured),

      },
      plans: healthPlans?.plans
        ?.filter((plan) => plan?.isSelected)
        ?.map((plan) => {
          return {
            name: plan?.name,
            code: plan?.code,
            covers: plan?.covers?.map((cover) => {
              return { name: cover?.name, index: cover?.index };
            }),
            packs: plan?.packs?.map((pack) => {
              return {
                name: pack?.name,
                index: pack?.index,
                addOnCovers: pack?.addOnCovers?.map((addOn) => {
                  return {
                    name: addOn?.name,
                    index: addOn?.index,
                    selected: addOn?.selected,
                  };
                }),
              };
            }),
            premium: {
              basePremium: plan?.premium?.basePremium,
              loadingDiscount: plan?.premium?.loadingDiscount,
              netPremium: plan?.premium?.netPremium,
              gst: plan?.premium?.gst,
              stampDuty: plan?.premium?.stampDuty,
              totalPremium: plan?.premium?.totalPremium,
              breakup: plan?.premium?.breakup?.map((brkup) => {
                return {
                  relationship: brkup?.relationship,
                  gender: brkup?.gender,
                  age: brkup?.age,
                  premium: brkup?.premium,
                };
              }),
              loading: plan?.premium?.loading?.map((loading) => {
                return {
                  name: loading?.name,
                  amount: loading?.amount,
                };
              }),
              discount: plan?.premium?.discount?.map((discount) => {
                return {
                  name: discount?.name,
                  amount: discount?.amount,
                };
              }),
            },
          };
        }),
      existingPolicyNumber,
      isExistingEmployee:
        isExistingEmployee?.toLowerCase() === 'yes' ? true : false,
    },
  };
};

const reformData = (val, returnType, isString) => {
  return val && val.toString().trim() !== ''
    ? isString === undefined || isString === true
      ? `${val}`
      : val
    : returnType;
};

const getDomainData = (
  domainArr,
  searchText,
  searchType,
  returnType,
) => {
  return domainArr.find(
    (d) =>
      d[`${searchType}`]?.toString()?.toLowerCase() ===
      searchText?.toString()?.toLowerCase(),
  )
    ? domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )[`${returnType}`]
    : '';
};

function NewCustomerForm({
  validate,
  setLocalNewCustomerValues,
  setDropdownDetails,
  onModalClose,
  lobCode,
  productCode,
  setCustomerNameQuoteSaved,
  doSaveQuote,
  selectedIntermediary,
  setEnableReinitialize,
}) {
  const { values, setFieldValue } = useQuantaFormikContext();
  const fetchQuery = useFetchQuery();
  const [loadingHealthQuotePlans, setLoadingHealthQuotePlans] =
    useState(false);
  const [errorHealthQuotePlans, setErrorHealthQuotePlans] =
    useState(null);
  const {
    loading,
    error,
    data: dropDownDetails,
  } = useQuery(CUSTOMER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => setDropdownDetails(data),
  });

  const {
    loading: loading_cust_type_domain,
    error: error_cust_type_domain,
    data: data_cust_type_domain,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
  });

  const repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 4,
  });
  const isOpenedFromFragment = useResponsiveParams({
    for_mobile: true,
    for_desktop: false,
  });
  if (loading || loading_cust_type_domain) {
    return (
      <div className="min-h-full">
        <Loading />
      </div>
    );
  }

  if (error || error_cust_type_domain) {
    return (
      <div className="min-h-full">
        <Error error={error || error_cust_type_domain} />
      </div>
    );
  }

  const newCustomerData = [
    {
      title: '',
      grid_data: [
        {
          type: 'select-tabs',
          name: 'customerType',
          colSpan: repeat,
          size: 'large',
          data: [
            {
              icon: () => <FontAwesomeIcon icon={faUserTag} />,
              label: 'Individual',
              value: data_cust_type_domain?.customerTypeList
                ? getDomainData(
                  data_cust_type_domain?.customerTypeList,
                  'Individual',
                  'value',
                  'code',
                )
                : '',
              onFieldChange: (values, _) => {
                setEnableReinitialize(false);
                if (
                  values.customerType ===
                  getDomainData(
                    data_cust_type_domain?.customerTypeList,
                    'Organisation',
                    'value',
                    'code',
                  )
                ) {
                  Object.keys(values.orgDetails).forEach((k) => {
                    setFieldValue(`orgDetails.${k}`, '');
                  });
                  setLocalNewCustomerValues({
                    customerType: getDomainData(
                      data_cust_type_domain?.customerTypeList,
                      'Individual',
                      'value',
                      'code',
                    ),
                  });
                }
              },
            },
            {
              icon: () => <FontAwesomeIcon icon={faBuilding} />,
              label: 'Organisation',
              value: data_cust_type_domain?.customerTypeList
                ? getDomainData(
                  data_cust_type_domain?.customerTypeList,
                  'Organisation',
                  'value',
                  'code',
                )
                : '',
              onFieldChange: (values, _) => {
                setEnableReinitialize(false);
                if (
                  values.customerType ===
                  getDomainData(
                    data_cust_type_domain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  )
                ) {
                  Object.keys(values.indvDetails).forEach((k) => {
                    setFieldValue(`indvDetails.${k}`, '');
                  });
                  setLocalNewCustomerValues({
                    customerType: getDomainData(
                      data_cust_type_domain?.customerTypeList,
                      'Organisation',
                      'value',
                      'code',
                    ),
                  });
                }
              },
            },
          ],
        },
        ...(values.customerType ===
          getDomainData(
            data_cust_type_domain?.customerTypeList,
            'Individual',
            'value',
            'code',
          )
          ? [
            {
              type: 'select',
              name: 'indvDetails.title',
              label: (
                <div>
                  Title <Text severity="error">*</Text>
                </div>
              ),
              searchable: true,
              data: dropDownDetails?.salutationList
                ? [
                  ...dropDownDetails.salutationList.map((s) => {
                    return {
                      label: s.value ? s.value : '',
                      value: s.code ? s.code : '',
                    };
                  }),
                ]
                : [],
            },
            {
              type: 'text',
              label: (
                <div>
                  First Name <Text severity="error">*</Text>
                </div>
              ),
              name: 'indvDetails.firstName',
              onKeyDown: (evt) => {
                if (
                  (evt?.target?.value?.toString()?.endsWith(' ') &&
                    evt?.key === ' ') ||
                  (evt?.target?.value?.toString()?.length === 0 &&
                    evt?.key === ' ')
                ) {
                  evt.preventDefault();
                }
              },
            },
            {
              type: 'text',
              label: (
                <div>
                  Middle Name <Text severity="error"></Text>
                </div>
              ),
              name: 'indvDetails.middleName',
              onKeyDown: (evt) => {
                if (
                  (evt?.target?.value?.toString()?.endsWith(' ') &&
                    evt?.key === ' ') ||
                  (evt?.target?.value?.toString()?.length === 0 &&
                    evt?.key === ' ')
                ) {
                  evt.preventDefault();
                }
              },
            },
            {
              type: 'text',
              label: (
                <div>
                  Last Name <Text severity="error">*</Text>
                </div>
              ),
              name: 'indvDetails.lastName',
              onKeyDown: (evt) => {
                if (
                  (evt?.target?.value?.toString()?.endsWith(' ') &&
                    evt?.key === ' ') ||
                  (evt?.target?.value?.toString()?.length === 0 &&
                    evt?.key === ' ')
                ) {
                  evt.preventDefault();
                }
              },
            },
            {
              type: 'email',
              label: (
                <div>
                  Email Id <Text severity="error">*</Text>
                </div>
              ),
              name: 'indvDetails.email',
            },
            {
              type: 'text',
              maxLength: 10,
              label: (
                <div>
                  Mobile Number <Text severity="error">*</Text>
                </div>
              ),
              name: 'indvDetails.mobileNumber',
            },
            // {
            //   type: 'date',
            //   maxdate: moment()
            //     .subtract(18, 'years')
            //     .subtract(1, 'days')
            //     .format('DD/MM/YYYY'),
            //   label: (
            //     <div>
            //       Date Of Birth <Text severity="error">*</Text>
            //     </div>
            //   ),
            //   name: 'indvDetails.dob',
            // },
          ]
          : [
            {
              type: 'text',
              label: (
                <div>
                  Organisation Name <Text severity="error">*</Text>
                </div>
              ),
              name: 'orgDetails.organisationName',
              onKeyDown: (evt) => {
                if (
                  (evt?.target?.value?.toString()?.endsWith(' ') &&
                    evt?.key === ' ') ||
                  (evt?.target?.value?.toString()?.length === 0 &&
                    evt?.key === ' ')
                ) {
                  evt.preventDefault();
                }
              },
            },
            {
              type: 'select',
              label: (
                <div>
                  Organisation Type <Text severity="error">*</Text>
                </div>
              ),
              name: 'orgDetails.organisationType',
              data: dropDownDetails?.organisationList
                ? [
                  ...dropDownDetails.organisationList.map(
                    (orgType) => {
                      return {
                        label: orgType.value ? orgType.value : '',
                        value: orgType.code ? orgType.code : '',
                      };
                    },
                  ),
                ]
                : [],
            },
            {
              type: 'text',
              maxLength: 40,
              label: (
                <div>
                  Contact Person <Text severity="error"></Text>
                </div>
              ),
              name: 'orgDetails.contactPerson',
              onKeyDown: (evt) => {
                if (
                  (evt?.target?.value?.toString()?.endsWith(' ') &&
                    evt?.key === ' ') ||
                  (evt?.target?.value?.toString()?.length === 0 &&
                    evt?.key === ' ')
                ) {
                  evt.preventDefault();
                }
              },
            },
            {
              type: 'text',
              maxLength: 10,
              label: (
                <div>
                  Mobile Number <Text severity="error">*</Text>
                </div>
              ),
              name: 'orgDetails.mobileNumber',
            },
            {
              type: 'email',
              label: (
                <div>
                  Email Id <Text severity="error">*</Text>
                </div>
              ),
              name: 'orgDetails.email',
            },
          ]),
      ],
    },
  ];

  const other_props = {
    flow: 'cols',
    repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
  };
  return (
    <QuantaForm className="space-y-4 h-full w-full">
      <div className="flex flex-col md:justify-between h-full pb-12">
        <div className="h-full">
          <InputGridGroup
            {...{ data: newCustomerData, ...other_props }}
          />
        </div>
        <div className="h-full flex flex-row justify-end items-end">
          <div>
            <Button
              flat={false}
              type="button"
              size="medium"
              className="w-32"
              disabled={
                loadingHealthQuotePlans
                  ? loadingHealthQuotePlans
                  : values.customerType ===
                    getDomainData(
                      data_cust_type_domain?.customerTypeList,
                      'Individual',
                      'value',
                      'code',
                    )
                    ? Object.keys(validate(values).indvDetails)
                      .length !== 0
                    : Object.keys(validate(values).orgDetails)
                      .length !== 0
              }
              onClick={async (_) => {
                try {
                  let fetchQueryState = fetchQuery({
                    query: QUERY_STATE,
                  });
                  setLoadingHealthQuotePlans(true);
                  let { data: state } = await fetchQueryState;

                  let { healthQuote, healthPlans } = state;
                  let {
                    quotationType,
                    members,
                    location,
                    cover,
                    existingPolicyNumber,
                    isExistingEmployee,
                    intermediaryDetails,
                    deductSumInsured,

                  } = healthQuote;
                 
                  setLoadingHealthQuotePlans(false);
                  const customerData =
                    values.customerType ===
                      getDomainData(
                        data_cust_type_domain?.customerTypeList,
                        'Individual',
                        'value',
                        'code',
                      )
                      ? {
                        id: null,
                        customerType: values.customerType,
                        title: reformData(
                          values?.indvDetails?.title,
                          '',
                        ),
                        firstName: reformData(
                          values?.indvDetails?.firstName,
                          '',
                        ),
                        middleName: reformData(
                          values?.indvDetails?.middleName,
                          '',
                        ),
                        lastName: reformData(
                          values?.indvDetails?.lastName,
                          '',
                        ),
                        fullName: reformData(
                          [
                            values?.indvDetails?.title.trim(),
                            values?.indvDetails?.firstName.trim(),
                            values?.indvDetails?.middleName.trim(),
                            values?.indvDetails?.lastName.trim(),
                          ]
                            .filter((n) => n)
                            .join(' '),
                          '',
                        ),
                        emailID: reformData(
                          values?.indvDetails?.email,
                          '',
                        ),
                        mobileNo: reformData(
                          values?.indvDetails?.mobileNumber,
                          '',
                        ),
                        proposerDOB: reformData(
                          values?.indvDetails?.dob,
                          '',
                        ),
                        permPincode: reformData(
                          healthQuote?.location?.pincode,
                          '',
                        ),
                        permCityTownVillage: reformData(
                          healthQuote?.location?.city,
                          '',
                        ),
                        permState: reformData(
                          healthQuote?.location?.state,
                          '',
                        ),
                        permDistrict: reformData(
                          healthQuote?.location?.district,
                          '',
                        ),
                        permCommAddressYN: false,
                      }
                      : {
                        id: null,
                        customerType: values.customerType,
                        orgName: reformData(
                          values?.orgDetails?.organisationName,
                          '',
                        ),
                        orgType: reformData(
                          values?.orgDetails?.organisationType,
                          '',
                        ),
                        contactName: reformData(
                          values?.orgDetails?.contactPerson,
                          '',
                        ),
                        mobileNo: reformData(
                          values?.orgDetails?.mobileNumber,
                          '',
                        ),
                        emailID: reformData(
                          values?.orgDetails?.email,
                          '',
                        ),
                        permPincode: reformData(
                          healthQuote?.location?.pincode,
                          '',
                        ),
                        permCityTownVillage: reformData(
                          healthQuote?.location?.city,
                          '',
                        ),
                        permState: reformData(
                          healthQuote?.location?.state,
                          '',
                        ),
                        permDistrict: reformData(
                          healthQuote?.location?.district,
                          '',
                        ),
                        permCommAddressYN: false,
                      };
                  const variables = saveQuoteVariables(
                    lobCode,
                    productCode,
                    customerData,
                    quotationType,
                    members,
                    cover,
                    healthPlans,
                    location,
                    existingPolicyNumber,
                    isExistingEmployee,
                    selectedIntermediary,
                    intermediaryDetails,
                    deductSumInsured,

                  );
                  setCustomerNameQuoteSaved(
                    values.customerType ===
                      getDomainData(
                        data_cust_type_domain?.customerTypeList,
                        'Individual',
                        'value',
                        'code',
                      )
                      ? `${values?.indvDetails?.title} ${values?.indvDetails?.firstName
                      }${values?.indvDetails?.middleName
                        ? ` ${values.indvDetails.middleName} `
                        : ' '
                      }${values?.indvDetails?.lastName}`
                      : values?.orgDetails?.organisationName,
                  );
                  doSaveQuote({ variables });
                  updateCustomerInformation({
                    customer: customerData,
                    customerMeta: {
                      crn: '',
                      isNewCustomer: true,
                      ifscCode: '',
                      bankName: '',
                      branchName: '',
                      bankAcno: '',
                      accountHolderName: '',
                      micrCode: '',
                    },
                  });
                  updateHealthQuote({
                    isQuoteSaving: true,
                  });
                  onModalClose();
                } catch (error) {
                  setLoadingHealthQuotePlans(false);
                  setErrorHealthQuotePlans(error.message);
                }
              }}
              iconPre={
                loadingHealthQuotePlans ? (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin={true}
                    className="ml-4 text-secondary"
                  />
                ) : errorHealthQuotePlans ? (
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className="ml-4"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} className="ml-4" />
                )
              }
            >
              <span className="pl-1 text-base">Save</span>
            </Button>
          </div>
        </div>
      </div>
    </QuantaForm>
  );
}

export default function ModalSaveQuote({
  saveQuoteDisplay,
  setSaveQuoteDisplay,
  setCustomerNameQuoteSaved,
  doSaveQuote,
  productCode,
  lobCode,
  selectedIntermediary,
}) {
  const [CRSL, setCRSL] = useState('');
  const {
    loading: loading_cust_type_domain,
    error: error_cust_type_domain,
    data: data_cust_type_domain,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loading_mobile_number_starting_with,
    error: error_mobile_number_starting_with,
    data: data_mobile_number_starting_with,
  } = useQuery(MOBILE_NUMBER_STARTING_WITH, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loading_1,
    error: error_1,
    data: state1,
  } = useQuery(QUERY_STATE, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loading_character_limit,
    error: error_character_limit,
    data: data_character_limit,
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
  });
  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });
  const [modalDisplay, setModalDisplay] = useState(false);
  const [
    localExistingCustomerValues,
    setLocalExistingCustomerValues,
  ] = useState({
    searchType: 'Mobile Number',
  });
  const [enableReinitialize, setEnableReinitialize] = useState(false);
  const [localNewCustomerValues, setLocalNewCustomerValues] =
    useState({});

  const fetchQuery = useFetchQuery();
  const { branding } = useContext(QuantaConfigContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      setModalDisplay(saveQuoteDisplay);
    }, 150);
    return () => clearTimeout(timer);
  }, [saveQuoteDisplay, setModalDisplay]);

  const [customerSearchMetaMessage, setCustomerSearchMetaMessage] =
    useState({ type: '', message: '' });

  const [isIdleDisplay, setIdleDisplay] = useState(true);
  const [existingCustomers, setExistingCustomers] = useState([]);
  const [loadingExistingCustomers, setLoadingExistingCustomers] =
    useState(false);
  const [customerDropdownDetails, setDropdownDetails] =
    useState(null);
  const [errors, setErrors] = useState({
    existingCustomers: '',
  });
  const getSearchTextPlaceholder = (searchType, customerType) => {
    switch (searchType) {
      case 'Customer Number':
        return 'Enter customer ID to search.';
      case 'Customer Name':
        return customerType ===
          getDomainData(
            data_cust_type_domain?.customerTypeList,
            'Individual',
            'value',
            'code',
          ) || !customerType
          ? 'Enter customer name to search.'
          : 'Enter organisation name to search.';
      case 'Mobile Number':
        return "Enter customer's mobile number to search.";
      default:
        return customerType ===
          getDomainData(
            data_cust_type_domain?.customerTypeList,
            'Individual',
            'value',
            'code',
          ) || !customerType
          ? "Enter customer's mobile number to search."
          : 'Enter organisation name to search.';
    }
  };

  const getSearchObject = (
    customerType,
    searchType,
    searchString,
  ) => {
    return {
      customer_type: customerType,
      customer_number:
        searchType === 'Customer Number' ? searchString : undefined,
      customer_name:
        searchType === 'Customer Name' ? searchString : undefined,
      mobile:
        searchType === 'Mobile Number' ? searchString : undefined,
    };
  };

  const validateNewCustomer = (values) => {
    const errors = {};
    if (
      values.customerType ===
      getDomainData(
        data_cust_type_domain?.customerTypeList,
        'Individual',
        'value',
        'code',
      )
    ) {
      errors.indvDetails = {};

      var mobileNumberValue =
        data_mobile_number_starting_with?.mobileNumberStartingWith
          ?.value;
      const firstNameValue =
        data_character_limit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'first name',
        );
      const middleNameValue =
        data_character_limit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'middle name',
        );
      const lastNameValue =
        data_character_limit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'last name',
        );

      if (!values.indvDetails.title) {
        errors.indvDetails.title = '* Required';
      }
      if (
        values.indvDetails.title &&
        customerDropdownDetails &&
        customerDropdownDetails.salutationList &&
        values.indvDetails.title !==
        getDomainData(
          customerDropdownDetails.salutationList,
          values.indvDetails.title,
          'value',
          'code',
        )
      ) {
        errors.indvDetails.title = '* Enter a valid title';
      } else if (
        customerDropdownDetails &&
        customerDropdownDetails.salutationList &&
        getDomainData(
          customerDropdownDetails?.salutationList,
          values?.indvDetails?.title,
          'code',
          'gender',
        )?.toLowerCase() &&
        values.indvDetails.gender?.toLowerCase() !==
        getDomainData(
          customerDropdownDetails?.salutationList,
          values?.indvDetails?.title,
          'code',
          'gender',
        )?.toLowerCase() &&
        (getDomainData(
          customerDropdownDetails?.genderList,
          values.indvDetails.gender,
          'code',
          'value',
        )?.toLowerCase() === 'male' ||
          getDomainData(
            customerDropdownDetails?.genderList,
            values.indvDetails.gender,
            'code',
            'value',
          )?.toLowerCase() === 'female')
      ) {
        errors.proposerDetails.title = '* Title mismatch with gender';
      }
      if (!values.indvDetails.firstName) {
        errors.indvDetails.firstName = '* Required';
      }
      if (
        values.indvDetails.firstName &&
        !values.indvDetails.firstName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.indvDetails.firstName =
          '* First Name can contain alphabets only';
      }
      if (
        values.indvDetails.firstName &&
        values.indvDetails.firstName.length > firstNameValue?.value
      ) {
        errors.indvDetails.firstName = `* First Name cannot be greater than ${firstNameValue?.value} characters`;
      }
      if (
        values.indvDetails.middleName &&
        !values.indvDetails.middleName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.indvDetails.middleName =
          '* Middle name can contain alphabets only';
      }
      if (
        values.indvDetails.middleName &&
        values.indvDetails.middleName.length > middleNameValue?.value
      ) {
        errors.indvDetails.middleName = `* Middle Name cannot be greater than ${middleNameValue?.value} characters`;
      }
      if (
        values.indvDetails.middleName &&
        !values.indvDetails.middleName.match(/\d/) &&
        !values.indvDetails.middleName.match(/^[a-zA-Z\s]+$/)
      ) {
        errors.indvDetails.middleName =
          '* No special characters allowed';
      }
      if (!values.indvDetails.lastName) {
        errors.indvDetails.lastName = '* Required';
      }
      if (
        values.indvDetails.lastName &&
        !values.indvDetails.lastName.match(/^[a-zA-Z. ]*$/)
      ) {
        errors.indvDetails.lastName =
          '* Last name can contain alphabets only';
      }
      if (
        values.indvDetails.lastName &&
        values.indvDetails.lastName.length > lastNameValue?.value
      ) {
        errors.indvDetails.lastName = `* Last Name cannot be greater than ${lastNameValue?.value} characters`;
      }
      if (!values.indvDetails.mobileNumber) {
        errors.indvDetails.mobileNumber = '* Required';
      }
      if (
        values.indvDetails.mobileNumber &&
        values.indvDetails.mobileNumber.toString().slice(0, 1) <
        mobileNumberValue
      ) {
        errors.indvDetails.mobileNumber = `* Mobile number must start with digit between ${mobileNumberValue} - 9`;
      }
      if (
        values.indvDetails.mobileNumber &&
        (values.indvDetails.mobileNumber.length !== 10 ||
          !values.indvDetails.mobileNumber.match(/^[0-9]+$/))
      ) {
        errors.indvDetails.mobileNumber =
          '* Mobile number must be of 10 digits';
      }
      if (!values.indvDetails.email) {
        errors.indvDetails.email = '* Required';
      }
      if (values.indvDetails.email) {
        let email_check = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
        );
        if (!email_check.test(values.indvDetails.email)) {
          errors.indvDetails.email =
            '* Please enter valid email address';
        }
      }
      // if (!values.indvDetails.dob) {
      //   errors.indvDetails.dob = '* Required';
      // }
      // if (values.indvDetails.dob) {
      //   if (moment(values.indvDetails.dob, 'DD/MM/YYYY').isAfter()) {
      //     errors.indvDetails.dob =
      //       '* Date of Birth cannot be a future date';
      //   }
      // }
    } else {
      errors.orgDetails = {};

      var mobileNumberValue =
        data_mobile_number_starting_with?.mobileNumberStartingWith
          ?.value;

      const orgNameValue =
        data_character_limit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'org name',
        );

      if (!values.orgDetails.organisationName) {
        errors.orgDetails.organisationName = '* Required';
      }
      if (
        values.orgDetails.organisationName &&
        !values.orgDetails.organisationName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.orgDetails.organisationName =
          '* Organisation name can contain alphabets only';
      }
      if (
        values.orgDetails.organisationName &&
        values.orgDetails.organisationName.length >
        orgNameValue?.value
      ) {
        errors.orgDetails.organisationName = `* Organisation Name cannot be greater than ${orgNameValue?.value} characters`;
      }
      if (!values.orgDetails.organisationType) {
        errors.orgDetails.organisationType = '* Required';
      }
      /**SU Divya : P2_928 -  Contact Person Name  as non-Mandatory*/
      // if (!values.orgDetails.contactPerson) {
      //   errors.orgDetails.contactPerson = '* Required';
      // }
      /**EU Divya : P2_928 -  Contact Person Name  as non-Mandatory*/
      if (
        values.orgDetails.contactPerson &&
        !values.orgDetails.contactPerson.match(/^[a-zA-Z ]*$/)
      ) {
        errors.orgDetails.contactPerson =
          '* Contact Person name can contain alphabets only';
      }
      if (!values.orgDetails.mobileNumber) {
        errors.orgDetails.mobileNumber = '* Required';
      }
      if (
        values.orgDetails.mobileNumber &&
        values.orgDetails.mobileNumber.toString().slice(0, 1) <
        mobileNumberValue
      ) {
        errors.orgDetails.mobileNumber = `* Mobile number must start with digit between ${mobileNumberValue} - 9`;
      }
      if (
        values.orgDetails.mobileNumber &&
        (values.orgDetails.mobileNumber.length !== 10 ||
          !values.orgDetails.mobileNumber.match(/^[0-9]+$/))
      ) {
        errors.orgDetails.mobileNumber =
          '* Mobile number must be of 10 digits';
      }
      if (!values.orgDetails.email) {
        errors.orgDetails.email = '* Required';
      }
      if (values.orgDetails.email) {
        let email_check = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
        );
        if (!email_check.test(values.orgDetails.email)) {
          errors.orgDetails.email =
            '* Please enter valid email address';
        }
      }
    }
    return errors;
  };
  const validatecrosssell = (values) => {

    const errors = {};
    errors.searchString =
      '* Customer ID cannot contain special characters';
    return errors;
  }
  const initialValuesNewCustomer = {
    customerType: localNewCustomerValues?.customerType
      ? localNewCustomerValues?.customerType
      : data_cust_type_domain?.customerTypeList
        ? getDomainData(
          data_cust_type_domain?.customerTypeList,
          'Individual',
          'value',
          'code',
        )
        : '',
    indvDetails: {
      title: '',
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      dob: '',
    },
    orgDetails: {
      organisationName: '',
      organisationType: '',
      contactPerson: '',
      mobileNumber: '',
      email: '',
    },
  };

  const onModalClose = () => {
    setModalDisplay(false);
    setSaveQuoteDisplay(false);
    setExistingCustomers([]);
    setLocalExistingCustomerValues({
      searchType: 'Mobile Number',
    });
    setEnableReinitialize(true);
    document.body.classList.remove('overflow-y-hidden');
  };

  const onNoResultsFound = () => {
    return errors.existingCustomers;
  };
  const icon_idle = (
    <img
      src={branding.illustration.no_data}
      alt="no data"
      className="lg:w-80 lg:h-80 w-64 h-64 opacity-50"
    />
  );

  const inputColSpans = useResponsiveParams({
    for_mobile: { searchString: 5, searchType: 3, button: 2 },
    for_desktop: { searchString: 3, searchType: 1, button: 1 },
  });

  const tableRepeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3,
  });

  const modalSize = useResponsiveParams({
    for_mobile: 'full',
    for_desktop: 'large',
    for_iPad: 'full',
  });

  const searchInput = {
    enableReinitialize,
    flow: 'cols',
    repeat: 5,
    data: [
      {
        type: 'select-tabs',
        name: 'customerType',
        colSpan: 5,
        size: 'large',
        data: [
          {
            icon: () => <FontAwesomeIcon icon={faUserTag} />,
            label: 'Individual',
            value: data_cust_type_domain?.customerTypeList
              ? getDomainData(
                data_cust_type_domain?.customerTypeList,
                'Individual',
                'value',
                'code',
              )
              : '',
            onFieldChange: (values, setFieldValue) => {
              setEnableReinitialize(false);
              if (
                values.customerType ===
                getDomainData(
                  data_cust_type_domain?.customerTypeList,
                  'Organisation',
                  'value',
                  'code',
                )
              ) {
                setFieldValue(
                  'customerType',
                  getDomainData(
                    data_cust_type_domain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  ),
                );
                setFieldValue('searchString', '');
                setFieldValue('searchType', 'Mobile Number');
                setLocalExistingCustomerValues({
                  ...localExistingCustomerValues,
                  customerType: getDomainData(
                    data_cust_type_domain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  ),
                  searchType: 'Mobile Number',
                });
                setExistingCustomers([]);
                setIdleDisplay(true);
              }
            },
          },
          {
            icon: () => <FontAwesomeIcon icon={faBuilding} />,
            label: 'Organisation',
            value: data_cust_type_domain?.customerTypeList
              ? getDomainData(
                data_cust_type_domain?.customerTypeList,
                'Organisation',
                'value',
                'code',
              )
              : '',
            onFieldChange: (values, setFieldValue) => {
              setEnableReinitialize(false);
              if (
                values.customerType ===
                getDomainData(
                  data_cust_type_domain?.customerTypeList,
                  'Individual',
                  'value',
                  'code',
                )
              ) {
                setFieldValue(
                  'customerType',
                  getDomainData(
                    data_cust_type_domain?.customerTypeList,
                    'Organisation',
                    'value',
                    'code',
                  ),
                );
                setFieldValue('searchString', '');
                setFieldValue('searchType', '');
                setLocalExistingCustomerValues({
                  ...localExistingCustomerValues,
                  customerType: getDomainData(
                    data_cust_type_domain?.customerTypeList,
                    'Organisation',
                    'value',
                    'code',
                  ),
                  searchType: '',
                });
                setExistingCustomers([]);
                setIdleDisplay(true);
              }
            },
          },
        ],
      },
      {
        type:
          localExistingCustomerValues?.searchType
            ?.toString()
            .toLowerCase() === 'mobile number'
            ? 'number'
            : 'text',
        name: 'searchString',
        step:
          localExistingCustomerValues?.searchType
            ?.toString()
            .toLowerCase() === 'mobile number'
            ? '1'
            : null,
        min: 1000000000,
        max: 9999999999,
        size: 'full',
        onKeyDown: (evt) => {
          if (
            (evt.key === 'e' &&
              localExistingCustomerValues?.searchType
                ?.toString()
                .toLowerCase() === 'mobile number') ||
            (localExistingCustomerValues?.searchType
              ?.toString()
              .toLowerCase() === 'customer name' &&
              (!evt.key.match(/^[a-zA-Z ]+$/) ||
                (evt.target.value.length === 0 && evt.key === ' ') ||
                (evt.target.value.length > 0 &&
                  evt.target.value[evt.target.value.length - 1] ===
                  ' ' &&
                  evt.key === ' ')))
          ) {
            evt.preventDefault();
          }
        },
        placeholder: getSearchTextPlaceholder(
          localExistingCustomerValues?.searchType,
          localExistingCustomerValues?.customerType,
        ),
        onDataChange: (val, _) => {
          setLocalExistingCustomerValues({
            ...localExistingCustomerValues,
            searchString: val,
          });
          setEnableReinitialize(false);
        },
        colSpan: inputColSpans.searchString,
      },
      {
        type: 'select',
        name: 'searchType',
        size: 'full',
        className: 'flex flex-row justify-center items-center py-0',
        colSpan: inputColSpans.searchType,
        value: localExistingCustomerValues.searchType,
        onDataChange: (val, _) => {
          setLocalExistingCustomerValues({
            ...localExistingCustomerValues,
            searchType: val,
          });
          setEnableReinitialize(false);
        },
        data:
          !localExistingCustomerValues.customerType ||
            localExistingCustomerValues.customerType?.toLowerCase() ===
            getDomainData(
              data_cust_type_domain?.customerTypeList,
              'Individual',
              'value',
              'code',
            )?.toLowerCase()
            ? [
              // { label: 'Customer Name', value: 'Customer Name' },
              { label: 'Customer ID', value: 'Customer Number' },
              { label: 'Mobile Number', value: 'Mobile Number' },
              { label: 'CKYC ID', value: 'CKYC Id' },
              { label: 'PAN Number', value: 'PAN No' },
            ]
            : [
              // {
              //   label: 'Organisation Name',
              //   value: 'Customer Name',
              // },
              { label: 'Customer ID', value: 'Customer Number' },
              { label: 'CKYC ID', value: 'CKYC Id' },
              { label: 'PAN Number', value: 'PAN No' },
            ],
      },
      {
        type: 'submit',
        colSpan: inputColSpans.button,
        iconPost: <FontAwesomeIcon icon={faSearch} />,
        children: 'Search',
        size: 'full',
      },
    ],
    initialValues: {
      customerType: localExistingCustomerValues?.customerType
        ? localExistingCustomerValues?.customerType
        : data_cust_type_domain?.customerTypeList
          ? getDomainData(
            data_cust_type_domain?.customerTypeList,
            'Individual',
            'value',
            'code',
          )
          : '',
      searchString: localExistingCustomerValues?.searchString
        ? localExistingCustomerValues?.searchString
        : '',
      searchType: localExistingCustomerValues.searchType,
    },
    validate: (values) => {
      const errors = {};

      var mobileNumberCode =
        data_mobile_number_starting_with?.mobileNumberStartingWith
          ?.code;
      var mobileNumberValue =
        data_mobile_number_starting_with?.mobileNumberStartingWith
          ?.value;

      const orgNameValue =
        data_character_limit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit?.code?.toLowerCase() === 'org name',
        );

      if (!values.customerType || values.customerType === '') {
        errors.customerType = '* Required';
      } else if (!values.searchString || values.searchString === '') {
        errors.searchString = '* Required';
      } else if (
        values.customerType ===
        getDomainData(
          data_cust_type_domain.customerTypeList,
          'Individual',
          'value',
          'code',
        ) &&
        typeof values.searchString === 'string' &&
        ((values.searchString.toLowerCase().startsWith('mrs') &&
          values.searchString.length < 6) ||
          (values.searchString.toLowerCase().startsWith('mr') &&
            values.searchString.length < 5) ||
          (values.searchString.toLowerCase().startsWith('dr') &&
            values.searchString.length < 5) ||
          (values.searchString.toLowerCase().startsWith('miss') &&
            values.searchString.length < 7))
      ) {
        errors.searchString =
          '* Customer cannot be searched only by title';
      } else if (
        values.customerType ===
        getDomainData(
          data_cust_type_domain.customerTypeList,
          'Individual',
          'value',
          'code',
        ) &&
        values.searchString.length < 4 &&
        values.searchType.toLowerCase() !== 'mobile number'
      ) {
        errors.searchString =
          '* Minimum 4 characters are required for individual customer search';
      } else if (
        data_cust_type_domain &&
        data_cust_type_domain.customerTypeList &&
        values.customerType ===
        getDomainData(
          data_cust_type_domain.customerTypeList,
          'Organisation',
          'value',
          'code',
        ) &&
        values.searchString.length < 3
      ) {
        errors.searchString =
          '* Minimum 3 characters are required for organisation/corporate customer search';
      } else if (
        data_cust_type_domain &&
        data_cust_type_domain.customerTypeList &&
        values.customerType ===
        getDomainData(
          data_cust_type_domain.customerTypeList,
          'Organisation',
          'value',
          'code',
        ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        values.searchString.length > orgNameValue?.value
      ) {
        errors.searchString = `* Organisation Name cannot be greater than ${orgNameValue.value} characters`;
      } else if (
        data_cust_type_domain.customerTypeList &&
        values.customerType ===
        getDomainData(
          data_cust_type_domain.customerTypeList,
          'Organisation',
          'value',
          'code',
        ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        !values.searchString.match(/^[a-zA-Z ]+$/)
      ) {
        errors.searchString =
          '* Organisation name contains only alphabets';
      } else if (
        values.customerType ===
        getDomainData(
          data_cust_type_domain.customerTypeList,
          'Individual',
          'value',
          'code',
        ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        values.searchString.match(/\d/)
      ) {
        errors.searchString =
          '* Customer name cannot be alphanumeric';
      } else if (
        values.customerType ===
        getDomainData(
          data_cust_type_domain.customerTypeList,
          'Individual',
          'value',
          'code',
        ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        !values.searchString.match(/^[a-zA-Z ]+$/)
      ) {
        errors.searchString =
          '* Customer name contains only alphabets';
      } else if (
        values.searchType.toLowerCase() ===
        mobileNumberCode.toLowerCase() &&
        values.searchString.toString().slice(0, 1) < mobileNumberValue
      ) {
        errors.searchString = `* Mobile number must start with digit between ${mobileNumberValue} - 9`;
      } else if (
        values.searchType.toLowerCase() === 'mobile number' &&
        (values.searchString.toString().length !== 10 ||
          !values.searchString.toString().match(/^[0-9]+$/))
      ) {
        errors.searchString = '* Mobile number must be of 10 digits';
      } else if (!values.searchType || values.searchType === '') {
        errors.searchType = '* Required';
      } else if (
        values?.searchType?.toString()?.toLowerCase() ===
        'customer number' &&
        !values?.searchString?.match(/^[a-zA-Z0-9]+$/)
      ) {
        errors.searchString =
          '* Customer ID cannot contain special characters';
      }
      return errors;
    },
    onSearch: async (values) => {
      const { searchType, customerType, searchString } = values;
      setIdleDisplay(false);
      try {
        setCRSL('')
        setExistingCustomers([]);
        setLoadingExistingCustomers(true);

        let queryOutput = fetchQuery({
          query: SEARCH_CUSTOMERS,
          variables: {
            filter: getSearchObject(
              customerType,
              searchType,
              searchString,
            ),
          },
        });
        let { data } = await queryOutput;
        setLoadingExistingCustomers(false);
        setExistingCustomers(data.customers);
        setCustomerSearchMetaMessage({
          type: data._customer_meta.metaMessage.type,
          message: data._customer_meta.metaMessage.message,
        });
      } catch (error) {
        setErrors({
          ...errors,
          existingCustomers: error.message,
        });
        setLoadingExistingCustomers(false);
        setExistingCustomers([]);
      }
    },
  };

  const searchResults = {
    data: existingCustomers,
    onIdle: () => {
      if (loadingExistingCustomers) {
        return <Loading />;
      } else if (isIdleDisplay) {
        return icon_idle;
      }
      return undefined;
    },
    dependencies: [
      localExistingCustomerValues?.customerType,
      localExistingCustomerValues?.searchString,
    ],
    columns: [
      {
        Header: 'Customer ID',
        accessor: 'cust_number',
      },
      {
        Header:
          !localExistingCustomerValues.customerType ||
            localExistingCustomerValues.customerType ===
            getDomainData(
              data_cust_type_domain?.customerTypeList,
              'Individual',
              'value',
              'code',
            )
            ? 'Customer Name'
            : 'Organisation Name',
        Cell: ({ row }) => (
          <span>
            {row.original.cust_type.value ===
              getDomainData(
                data_cust_type_domain?.customerTypeList,
                'Individual',
                'value',
                'code',
              )
              ? row.original.indv_detail.full_name
              : row.original.org_detail.org_name}
          </span>
        ),
      },
      {
        Header: 'Location',
        Cell: ({ row }) => {
          return (
            <div className="text-base">
              {row.original.permanent_address.location}
            </div>
          );
        },
      },
      {
        Header: 'Contact',
        Cell: ({ row }) => {
          return (
            <span>
              <div className="flex flex-col -mb-1 -mt-1 item-baseline justify-center">
                <div className="text-base">
                  {row.original.contact.mobile}
                </div>
                <div className="text-base">
                  {row.original.contact.email}
                </div>
              </div>
            </span>
          );
        },
      },
    ].filter((d) => d.Header !== undefined),
    grid: {
      repeat: 1,
      gap: 2,
      gapX: 2,
      gapY: 2,
      gridClassName: 'w-full',
      gridItemsArr:
        existingCustomers.length > 0
          ? // &&
          // existingCustomers[0].cust_type.value ===
          //   getDomainData(
          //     data_cust_type_domain?.customerTypeList,
          //     'Individual',
          //     'value',
          //     'code',
          //   )
          existingCustomers?.map((customerData) => {
            return {
              id: `${customerData?.cust_number}`,
              content: (
                <Paper
                  className={`border-2 rounded cursor-pointer p-4 h-full hover:bg-neutral-light`}
                >
                  <Text
                    className={
                      'flex flex-col h-full w-full justify-between'
                    }
                  >
                    <Text
                      className={
                        'flex items-center justify-between'
                      }
                    >
                      <Text
                        className={
                          'font-semibold flex space-x-4 items-start'
                        }
                      >
                        <Text
                          className={
                            'flex flex-col justify-start items-center'
                          }
                        >
                          <Text
                            severity={'info'}
                            className="border-2 px-2 py-1 rounded-lg bg-white"
                          >
                            {customerData?.cust_type?.value
                              ?.toString()
                              ?.toLowerCase() === 'organisation' ? (
                              <FontAwesomeIcon
                                icon={faUniversity}
                                size={'2x'}
                              />
                            ) : (
                              <FontAwesomeIcon
                                icon={faUser}
                                size={'2x'}
                              />
                            )}
                          </Text>
                        </Text>
                        <Text className={'flex flex-col'}>
                          <Text
                            severity={'info'}
                            className={'font-semibold'}
                          >
                            {`${customerData.cust_type.value ===
                                'Individual'
                                ? customerData.indv_detail.full_name
                                : customerData.org_detail.org_name
                              }`}
                          </Text>
                          <Text
                            severity={'neutral-darker'}
                            type={'label'}
                          >
                            {customerData.cust_number}
                          </Text>
                        </Text>
                      </Text>
                    </Text>
                    <Grid repeat={3} className={'w-full'}>
                      {customerData.permanent_address.location ? (
                        <GridItem
                          colSpan={1}
                          className={
                            screenType === 'desktop'
                              ? 'flex space-x-2 w-full justify-start ml-16 mt-2'
                              : 'flex space-x-2 w-full justify-start ml-2 mt-2'
                          }
                        >
                          <Text>
                            <FontAwesomeIcon
                              icon={faMapMarkerAlt}
                            />
                          </Text>
                          <Text>
                            {
                              customerData.permanent_address
                                .location
                            }
                          </Text>
                        </GridItem>
                      ) : (
                        <GridItem colSpan={1}>
                          <></>
                        </GridItem>
                      )}
                      {customerData.contact.mobile ? (
                        <GridItem
                          colSpan={1}
                          className={
                            screenType === 'desktop'
                              ? 'flex justify-center space-x-2 w-full mt-2'
                              : 'flex space-x-2 w-full mt-2'
                          }
                        >
                          <Text>
                            <FontAwesomeIcon icon={faMobileAlt} />
                          </Text>
                          <Text>{customerData.contact.mobile}</Text>
                        </GridItem>
                      ) : (
                        <GridItem colSpan={1}>
                          <></>
                        </GridItem>
                      )}
                      {customerData.contact.email ? (
                        <GridItem
                          colSpan={1}
                          className={
                            screenType === 'desktop'
                              ? 'flex space-x-2 w-full mt-2 ml-7'
                              : 'flex space-x-2 w-full mt-2'
                          }
                        >
                          <Text>
                            <FontAwesomeIcon icon={faEnvelope} />
                          </Text>
                          <Text>{customerData.contact.email}</Text>
                        </GridItem>
                      ) : (
                        <GridItem colSpan={1}>
                          <></>
                        </GridItem>
                      )}
                    </Grid>
                  </Text>
                </Paper>
              ),
              onClick: async () => {
                try {
                  let fetchQueryState = fetchQuery({
                    query: QUERY_STATE,
                  });
                  setLoadingExistingCustomers(true);
                  let { data: state } = await fetchQueryState;

                  if (state.healthQuote.existingPolicyNumber !== '' &&
                    state.healthPlans.plans[0]?.premium?.CustID?.toString() !==
                    customerData?.cust_number?.toString()) {
                    setCRSL(1)
                    setLoadingExistingCustomers(false);
                  }
                  else {
                    setCRSL('')
                    setLoadingExistingCustomers(false);
                    let { healthQuote, healthPlans } = state;
                    let {
                      quotationType,
                      members,
                      location,
                      cover,
                      existingPolicyNumber,
                      isExistingEmployee,
                      intermediaryDetails,
                      deductSumInsured,

                    } = healthQuote;
                    setCustomerNameQuoteSaved(
                      customerData?.cust_type?.value ===
                        getDomainData(
                          data_cust_type_domain?.customerTypeList,
                          'Individual',
                          'value',
                          'code',
                        )
                        ? customerData?.indv_detail?.full_name
                        : customerData?.org_detail?.org_name,
                    );
                    let customerDataModified =
                      customerData?.cust_type?.value ===
                        getDomainData(
                          data_cust_type_domain?.customerTypeList,
                          'Individual',
                          'value',
                          'code',
                        )
                        ? {
                          id: customerData?.cust_number,
                          customerType:
                            customerData?.cust_type?.code,
                          title: reformData(
                            customerData?.indv_detail?.title?.code,
                            '',
                          ),
                          firstName: reformData(
                            customerData?.indv_detail?.first_name,
                            '',
                          ),
                          middleName: reformData(
                            customerData?.indv_detail?.middle_name,
                            '',
                          ),
                          fullName: reformData(
                            customerData?.indv_detail?.full_name,
                            '',
                          ),
                          lastName: reformData(
                            customerData?.indv_detail?.surname,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          proposerDOB: reformData(
                            customerData?.indv_detail
                              ?.date_of_birth,
                            '',
                          ),
                        }
                        : {
                          id: customerData?.cust_number,
                          customerType:
                            customerData?.cust_type?.code,
                          orgName: reformData(
                            customerData?.org_detail?.org_name,
                            '',
                          ),
                          orgType: reformData(
                            customerData?.org_detail?.org_type
                              ?.code,
                            '',
                          ),
                          contactName: reformData(
                            customerData?.org_detail?.contact_name,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                        };
                    const variables = saveQuoteVariables(
                      lobCode,
                      productCode,
                      customerDataModified,
                      quotationType,
                      members,
                      cover,
                      healthPlans,
                      location,
                      existingPolicyNumber,
                      isExistingEmployee,
                      selectedIntermediary,
                      intermediaryDetails,
                      deductSumInsured,

                    );
                    doSaveQuote({ variables });
                    updateCustomerInformation({
                      customer: customerDataModified,
                      customerMeta: {
                        crn: '',
                        isNewCustomer: false,
                        ifscCode: '',
                        bankName: '',
                        branchName: '',
                        bankAcno: '',
                        accountHolderName: '',
                        micrCode: '',
                      },
                    });
                    updateHealthQuote({
                      isQuoteSaving: true,
                    });
                    onModalClose();
                  }
                } catch (error) {
                  setErrors({
                    existingCustomers: error.message,
                  });
                  setLoadingExistingCustomers(false);
                }
              },
              colSpan: 1,
            };
          })
          : [],
    },
    card: {
      gap: 2,
      gapX: 2,
      gapY: 2,
      cardClassName: 'w-full',
      cardItemsArr:
        existingCustomers.length > 0
          ? // &&
          // existingCustomers[0].cust_type.value ===
          //   getDomainData(
          //     data_cust_type_domain?.customerTypeList,
          //     'Individual',
          //     'value',
          //     'code',
          //   )
          existingCustomers?.map((customerData) => {
            return {
              id: `${customerData?.cust_number}`,
              content: (
                <Paper
                  className={` border-2 rounded cursor-pointer p-4 h-full hover:bg-neutral-light`}
                >
                  <Text
                    className={
                      'flex flex-col h-full w-full justify-start'
                    }
                  >
                    <Text
                      className={
                        'flex items-center justify-between'
                      }
                    >
                      <Text
                        className={
                          'font-semibold flex space-x-2 items-start'
                        }
                      >
                        <Text className={'flex flex-col'}>
                          <Text
                            severity={'info'}
                            className={'font-semibold'}
                          >
                            {`${customerData.cust_type.value ===
                                'Individual'
                                ? customerData.indv_detail.full_name
                                : customerData.org_detail.org_name
                              }`}
                          </Text>
                          <Text
                            severity={'neutral-darker'}
                            type={'label'}
                          >
                            {customerData.cust_number}
                          </Text>
                        </Text>
                      </Text>
                    </Text>
                    <Grid
                      repeat={2}
                      gap={1}
                      className={'w-full h-full mt-2'}
                    >
                      {customerData.permanent_address.location ? (
                        <GridItem
                          colSpan={1}
                          className={
                            'flex space-x-2 w-full justify-start items-center'
                          }
                        >
                          <Text type={'label'}>
                            <FontAwesomeIcon
                              icon={faMapMarkerAlt}
                            />
                          </Text>
                          <Text type={'label'}>
                            {
                              customerData.permanent_address
                                .location
                            }
                          </Text>
                        </GridItem>
                      ) : (
                        <GridItem colSpan={1}>
                          <></>
                        </GridItem>
                      )}
                      {customerData.contact.mobile ? (
                        <GridItem
                          colSpan={1}
                          className={
                            screenType === 'mobile'
                              ? 'flex space-x-2 w-full justify-end'
                              : 'flex space-x-2 w-full justify-start'
                          }
                        >
                          <Text type={'label'}>
                            <FontAwesomeIcon icon={faMobileAlt} />
                          </Text>
                          <Text type={'label'}>
                            {customerData.contact.mobile}
                          </Text>
                        </GridItem>
                      ) : (
                        <GridItem colSpan={1}>
                          <></>
                        </GridItem>
                      )}
                      {customerData.contact.email ? (
                        <GridItem
                          colSpan={1}
                          className={
                            'flex space-x-2 w-full items-center'
                          }
                        >
                          <Text type={'label'}>
                            <FontAwesomeIcon icon={faEnvelope} />
                          </Text>
                          <Text type={'label'}>
                            {customerData.contact.email}
                          </Text>
                        </GridItem>
                      ) : (
                        <GridItem colSpan={1}>
                          <></>
                        </GridItem>
                      )}
                    </Grid>
                  </Text>
                </Paper>
              ),
              onClick: async () => {
                try {
                  let fetchQueryState = fetchQuery({
                    query: QUERY_STATE,
                  });
                  setLoadingExistingCustomers(true);
                  let { data: state } = await fetchQueryState;

                  if (state.healthQuote.existingPolicyNumber !== '' &&
                    state.healthPlans.plans[0]?.premium?.CustID?.toString() !==
                    customerData?.cust_number?.toString()) {
                    setCRSL(1)
                    setLoadingExistingCustomers(false);
                  }
                  else {
                    setCRSL('')
                    setLoadingExistingCustomers(false);
                    let { healthQuote, healthPlans } = state;
                    let {
                      quotationType,
                      members,
                      location,
                      cover,
                      existingPolicyNumber,
                      isExistingEmployee,
                      intermediaryDetails,
                      deductSumInsured,

                    } = healthQuote;
                    // console.log("------------------------------------------------->,",healthQuote);

                    setCustomerNameQuoteSaved(
                      customerData?.cust_type?.value ===
                        getDomainData(
                          data_cust_type_domain?.customerTypeList,
                          'Individual',
                          'value',
                          'code',
                        )
                        ? customerData?.indv_detail?.full_name
                        : customerData?.org_detail?.org_name,
                    );
                    let customerDataModified =
                      customerData?.cust_type?.value ===
                        getDomainData(
                          data_cust_type_domain?.customerTypeList,
                          'Individual',
                          'value',
                          'code',
                        )
                        ? {
                          id: customerData?.cust_number,
                          customerType:
                            customerData?.cust_type?.code,
                          title: reformData(
                            customerData?.indv_detail?.title?.code,
                            '',
                          ),
                          firstName: reformData(
                            customerData?.indv_detail?.first_name,
                            '',
                          ),
                          middleName: reformData(
                            customerData?.indv_detail?.middle_name,
                            '',
                          ),
                          fullName: reformData(
                            customerData?.indv_detail?.full_name,
                            '',
                          ),
                          lastName: reformData(
                            customerData?.indv_detail?.surname,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          proposerDOB: reformData(
                            customerData?.indv_detail
                              ?.date_of_birth,
                            '',
                          ),
                        }
                        : {
                          id: customerData?.cust_number,
                          customerType:
                            customerData?.cust_type?.code,
                          orgName: reformData(
                            customerData?.org_detail?.org_name,
                            '',
                          ),
                          orgType: reformData(
                            customerData?.org_detail?.org_type
                              ?.code,
                            '',
                          ),
                          contactName: reformData(
                            customerData?.org_detail?.contact_name,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                        };
                    const variables = saveQuoteVariables(
                      lobCode,
                      productCode,
                      customerDataModified,
                      quotationType,
                      members,
                      cover,
                      healthPlans,
                      location,
                      existingPolicyNumber,
                      isExistingEmployee,
                      selectedIntermediary,
                      intermediaryDetails,
                      deductSumInsured,

                    );
                    doSaveQuote({ variables });
                    updateCustomerInformation({
                      customer: customerDataModified,
                      customerMeta: {
                        crn: '',
                        isNewCustomer: false,
                        ifscCode: '',
                        bankName: '',
                        branchName: '',
                        bankAcno: '',
                        accountHolderName: '',
                        micrCode: '',
                      },
                    });
                    updateHealthQuote({
                      isQuoteSaving: true,
                    });
                    onModalClose();
                  }
                } catch (error) {
                  setErrors({
                    existingCustomers: error.message,
                  });
                  setLoadingExistingCustomers(false);
                }
              },
              colSpan: 1,
            };
          })
          : [],
    },
    // list: existingCustomers.map((customerData) => {
    //   return {
    //     title: `${
    //       customerData.cust_type.value ===
    //       getDomainData(
    //         data_cust_type_domain?.customerTypeList,
    //         'Individual',
    //         'value',
    //         'code',
    //       )
    //         ? customerData.indv_detail.full_name
    //         : customerData.org_detail.org_name
    //     } (${customerData.cust_number})`,
    //     subtitle: `${customerData.permanent_address.location}`,
    //     onClick: async () => {
    //       try {
    //         let fetchQueryState = fetchQuery({
    //           query: QUERY_STATE,
    //         });
    //         setLoadingExistingCustomers(true);
    //         let { data: state } = await fetchQueryState;
    //         setLoadingExistingCustomers(false);
    //         let { healthQuote, healthPlans } = state;
    //         let {
    //           quotationType,
    //           members,
    //           location,
    //           cover,
    //           existingPolicyNumber,
    //           isExistingEmployee,
    //           intermediaryDetails,
    //         } = healthQuote;
    //         setCustomerNameQuoteSaved(
    //           customerData?.cust_type?.value ===
    //             getDomainData(
    //               data_cust_type_domain?.customerTypeList,
    //               'Individual',
    //               'value',
    //               'code',
    //             )
    //             ? customerData?.indv_detail?.full_name
    //             : customerData?.org_detail?.org_name,
    //         );
    //         customerData =
    //           customerData?.cust_type?.value ===
    //           getDomainData(
    //             data_cust_type_domain?.customerTypeList,
    //             'Individual',
    //             'value',
    //             'code',
    //           )
    //             ? {
    //                 id: customerData?.cust_number,
    //                 customerType: customerData?.cust_type?.code,
    //                 title: reformData(
    //                   customerData?.indv_detail?.title?.code,
    //                   '',
    //                 ),
    //                 firstName: reformData(
    //                   customerData?.indv_detail?.first_name,
    //                   '',
    //                 ),
    //                 middleName: reformData(
    //                   customerData?.indv_detail?.middle_name,
    //                   '',
    //                 ),
    //                 fullName: reformData(
    //                   customerData?.indv_detail?.full_name,
    //                   '',
    //                 ),
    //                 lastName: reformData(
    //                   customerData?.indv_detail?.surname,
    //                   '',
    //                 ),
    //                 emailID: reformData(
    //                   customerData?.contact?.email,
    //                   '',
    //                 ),
    //                 mobileNo: reformData(
    //                   customerData?.contact?.mobile,
    //                   '',
    //                 ),
    //                 proposerDOB: reformData(
    //                   customerData?.indv_detail?.date_of_birth,
    //                   '',
    //                 ),
    //               }
    //             : {
    //                 id: customerData?.cust_number,
    //                 customerType: customerData?.cust_type?.code,
    //                 orgName: reformData(
    //                   customerData?.org_detail?.org_name,
    //                   '',
    //                 ),
    //                 orgType: reformData(
    //                   customerData?.org_detail?.org_type?.code,
    //                   '',
    //                 ),
    //                 contactName: reformData(
    //                   customerData?.org_detail?.contact_name,
    //                   '',
    //                 ),
    //                 mobileNo: reformData(
    //                   customerData?.contact?.mobile,
    //                   '',
    //                 ),
    //                 emailID: reformData(
    //                   customerData?.contact?.email,
    //                   '',
    //                 ),
    //               };
    //         const variables = saveQuoteVariables(
    //           lobCode,
    //           productCode,
    //           customerData,
    //           quotationType,
    //           members,
    //           cover,
    //           healthPlans,
    //           location,
    //           existingPolicyNumber,
    //           isExistingEmployee,
    //           selectedIntermediary,
    //           intermediaryDetails,
    //         );
    //         doSaveQuote({ variables });
    //         updateCustomerInformation({
    //           customer: customerData,
    //           customerMeta: {
    //             crn: '',
    //             isNewCustomer: false,
    //             ifscCode: '',
    //             bankName: '',
    //             branchName: '',
    //             bankAcno: '',
    //             accountHolderName: '',
    //             micrCode: '',
    //           },
    //         });
    //         updateHealthQuote({
    //           isQuoteSaving: true,
    //         });
    //         onModalClose();
    //       } catch (error) {
    //         setErrors({
    //           existingCustomers: error.message,
    //         });
    //         setLoadingExistingCustomers(false);
    //       }
    //     },
    //   };
    // }),
    onRowClick: async (customerData) => {
      try {
        let fetchQueryState = fetchQuery({
          query: QUERY_STATE,
        });
        setLoadingExistingCustomers(true);
        let { data: state } = await fetchQueryState;

        if (state.healthQuote.existingPolicyNumber !== '' &&
          state.healthPlans.plans[0]?.premium?.CustID?.toString() !==
          customerData?.cust_number?.toString()) {
          setCRSL(1)
          setLoadingExistingCustomers(false);
        }
        else {
          setCRSL('')
          setLoadingExistingCustomers(false);
          let { healthQuote, healthPlans } = state;
          let {
            quotationType,
            members,
            location,
            cover,
            existingPolicyNumber,
            isExistingEmployee,
            intermediaryDetails,
            deductSumInsured,

          } = healthQuote;
          // console.log("------------------------------------------------->,",healthQuote);

          setCustomerNameQuoteSaved(
            customerData?.cust_type?.value ===
              getDomainData(
                data_cust_type_domain?.customerTypeList,
                'Individual',
                'value',
                'code',
              )
              ? customerData?.indv_detail?.full_name
              : customerData?.org_detail?.org_name,
          );
          customerData =
            customerData?.cust_type?.value ===
              getDomainData(
                data_cust_type_domain?.customerTypeList,
                'Individual',
                'value',
                'code',
              )
              ? {
                id: customerData?.cust_number,
                customerType: customerData?.cust_type?.code,
                title: reformData(
                  customerData?.indv_detail?.title?.code,
                  '',
                ),
                firstName: reformData(
                  customerData?.indv_detail?.first_name,
                  '',
                ),
                middleName: reformData(
                  customerData?.indv_detail?.middle_name,
                  '',
                ),
                fullName: reformData(
                  customerData?.indv_detail?.full_name,
                  '',
                ),
                lastName: reformData(
                  customerData?.indv_detail?.surname,
                  '',
                ),
                emailID: reformData(customerData?.contact?.email, ''),
                mobileNo: reformData(
                  customerData?.contact?.mobile,
                  '',
                ),
                proposerDOB: reformData(
                  customerData?.indv_detail?.date_of_birth,
                  '',
                ),
              }
              : {
                id: customerData?.cust_number,
                customerType: customerData?.cust_type?.code,
                orgName: reformData(
                  customerData?.org_detail?.org_name,
                  '',
                ),
                orgType: reformData(
                  customerData?.org_detail?.org_type?.code,
                  '',
                ),
                contactName: reformData(
                  customerData?.org_detail?.contact_name,
                  '',
                ),
                mobileNo: reformData(
                  customerData?.contact?.mobile,
                  '',
                ),
                emailID: reformData(customerData?.contact?.email, ''),
              };
          const variables = saveQuoteVariables(
            lobCode,
            productCode,
            customerData,
            quotationType,
            members,
            cover,
            healthPlans,
            location,
            existingPolicyNumber,
            isExistingEmployee,
            selectedIntermediary,
            intermediaryDetails,
            deductSumInsured,

          );
          doSaveQuote({ variables });
          updateCustomerInformation({
            customer: customerData,
            customerMeta: {
              crn: '',
              isNewCustomer: false,
              ifscCode: '',
              bankName: '',
              branchName: '',
              bankAcno: '',
              accountHolderName: '',
              micrCode: '',
            },
          });
          updateHealthQuote({
            isQuoteSaving: true,
          });
          onModalClose();
        }
      } catch (error) {
        setErrors({
          existingCustomers: error.message,
        });
        setLoadingExistingCustomers(false);
      }
    },
    sortBy: { id: 'cust_number', desc: false },
  };

  const paginationInput = {
    offset: 0,
    PAGE_SIZE: 4,
  };

  const onMessage = () => {

    let crosssell = 'existing customer policy previous customer ID is not matching with selected customer ID'
    return (
      customerSearchMetaMessage &&
        customerSearchMetaMessage.type &&
        customerSearchMetaMessage.message &&
        CRSL.toString() === '' ? (
        <Text
          severity={customerSearchMetaMessage.type}
          className="space-x-1"
        >
          <div className="flex flex-row">
            <div>
              <FontAwesomeIcon
                icon={
                  customerSearchMetaMessage.type === 'info'
                    ? faExclamationCircle
                    : customerSearchMetaMessage.type === 'warning'
                      ? faExclamationTriangle
                      : faTimesCircle
                }
                className={`mr-1 text-${customerSearchMetaMessage.type}`}
              />
            </div>
            <div>
              {customerSearchMetaMessage.message}
            </div>
          </div>
        </Text>
      ) : (<Text
        severity="error"
        className="space-x-1"
      >
        <div className="flex flex-row">
          <div>
            <FontAwesomeIcon
              icon={
                faExclamationCircle
              }
              className={`mr-1 text-error`}
            />
          </div>
          <div>
            {`existing customer policy previous customer ID is not matching with selected customer ID`}
          </div>
        </div>
      </Text>)
    );
  };

  const renderTabData = [
    {
      icon: <FontAwesomeIcon icon={faUserCheck} />,
      label: 'Existing Customer',
      onTabClick: () => {
        setEnableReinitialize(false);
      },
      tab_data: (
        <div className="flex flex-col justify-between h-full">
          <div>
            <SearchResultsAdvanced
              {...{
                searchInput,
                searchResults,
                paginationInput,
                onMessage,
                onNoResultsFound,
                isModalDisplay: true,
                firstRowClickRequired: false,
                switchViewEnabled: true,
              }}
            />
          </div>
        </div>
      ),
    },
    state1.healthQuote.existingPolicyNumber === '' ?
      {
        icon: <FontAwesomeIcon icon={faUserPlus} />,
        label: 'New Customer',
        onTabClick: () => {
          setEnableReinitialize(false);
        },
        tab_data: (
          <QuantaFormik
            {...{
              initialValues: initialValuesNewCustomer,
              validate: validateNewCustomer,
              enableReinitialize: true,
            }}
          >
            <NewCustomerForm
              {...{
                validate: validateNewCustomer,
                setLocalNewCustomerValues,
                onModalClose,
                setDropdownDetails,
                lobCode,
                productCode,
                setCustomerNameQuoteSaved,
                doSaveQuote,
                selectedIntermediary,
                setEnableReinitialize,
              }}
            />
          </QuantaFormik>
        ),
      } : [],
  ];

  return (
    <Modal
      display={modalDisplay}
      size={modalSize}
      title={'Save Quote'}
      className="min-h-screen flex flex-col justify-start"
      onClose={onModalClose}
      severity={'action'}
    >
      {(loading_cust_type_domain ||
        loading_character_limit ||
        loading_mobile_number_starting_with) && (
          <div className="h-full w-full">
            <Loading />
          </div>
        )}
      {(error_cust_type_domain ||
        error_character_limit ||
        error_mobile_number_starting_with) && (
          <div className="h-full w-full">
            <Error
              error={
                error_cust_type_domain ||
                error_character_limit ||
                error_mobile_number_starting_with
              }
            />
          </div>
        )}
      {!loading_cust_type_domain &&
        !error_cust_type_domain &&
        !loading_mobile_number_starting_with &&
        !loading_character_limit &&
        !error_mobile_number_starting_with &&
        !error_character_limit && (
          <MixedTabbedDataGroup
            data={renderTabData}
            textType="normal"
            titleSeverity="info"
            repeat={tableRepeat}
            nullData={() => (
              <Text severity="neutral">Not Captured</Text>
            )}
          />
        )}
    </Modal>
  );
}
